export default "__VITE_ASSET__CQoYWnSD__"